"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddInventorySubjectCommand = void 0;
const validator_1 = require("@leavy/validator");
const StepCommand_1 = require("../../common/command/StepCommand");
const OnboardingId_1 = require("../../common/domain/OnboardingId");
const cq_core_1 = require("@leavy/cq-core");
const base_1 = require("../../base");
const InventorySubject_1 = require("../domain/inventory/InventorySubject");
let AddInventorySubjectCommand = class AddInventorySubjectCommand extends StepCommand_1.StepCommand {
    constructor() {
        super(...arguments);
        this.onboardingId = OnboardingId_1.OnboardingId.HL;
    }
};
__decorate([
    (0, validator_1.Equals)(OnboardingId_1.OnboardingId.HL),
    __metadata("design:type", String)
], AddInventorySubjectCommand.prototype, "onboardingId", void 0);
__decorate([
    (0, validator_1.IsString)(),
    (0, validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], AddInventorySubjectCommand.prototype, "subjectName", void 0);
__decorate([
    (0, validator_1.IsEnum)(InventorySubject_1.InventorySubjectType),
    __metadata("design:type", String)
], AddInventorySubjectCommand.prototype, "subjectType", void 0);
AddInventorySubjectCommand = __decorate([
    (0, cq_core_1.RpcInvocable)({
        namespace: base_1.ONBOARDING_SERVICE_NAME,
        alias: "add_inventory_subject",
    })
], AddInventorySubjectCommand);
exports.AddInventorySubjectCommand = AddInventorySubjectCommand;
//# sourceMappingURL=AddInventorySubjectCommand.js.map